@if (failure(); as failure) {
  <main class="text-text-primary mx-auto flex max-w-xl flex-col gap-4 p-8">
    <p [attr.data-testid]="'terms-page-' + failure">{{ messages[failure] }}</p>
    <a class="btn-primary self-start" href="/">{{ messages.login }}</a>
  </main>
}
